var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"}],staticClass:"wrapper"},[_c('div',{attrs:{"id":"pano-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }